import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ReconcileHtmlLinkService {
  constructor(private router: Router) {}

  addClickEventListenerForInternalRoutes(anchor: HTMLAnchorElement) {
    const href = anchor.getAttribute('href');
    const isHttpUrl = this.isValidHttpUrl(href);

    if (!isHttpUrl) {
      anchor.addEventListener('click', this.handleAnchorClick);
    }
  }

  isValidHttpUrl(href: string | null) {
    let url;

    if (!href) return false;

    try {
      url = new URL(href);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  public handleAnchorClick = (event: Event) => {
    event.preventDefault();
    const anchor = event.target as HTMLAnchorElement;
    const href = anchor.getAttribute('href');

    this.router.navigate([href]);
  };
}
